import { Component,ViewChild,ElementRef } from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {EcomanagerService} from '../ecomanager/Ecomanager.service';

@Component({
  templateUrl: './Ecompliance.component.html',
  styleUrls: ['./Ecompliance.component.css']
})
export class EcomplianceComponent {
  private iframeLoaded = false;

  hasCredentials = false;
  formSubmited = false;
  isLoading = true;
  subscription: any;
  private formUpdated = false;
  @ViewChild('form', { static: true }) form: ElementRef;
  @ViewChild('formLogin', { static: true }) formLogin: ElementRef;
  @ViewChild('formLoginFirstTime', { static: true }) formLoginFirstTime: ElementRef;
  @ViewChild('javaxFacesViewState', { static: true }) javaxFacesViewState: ElementRef;
  @ViewChild('formLoginAceptarBtn', { static: true }) formLoginAceptarBtn: ElementRef;
  @ViewChild('formLoginUsuario', { static: true }) formLoginUsuario: ElementRef;
  @ViewChild('formLoginPassword', { static: true }) formLoginPassword: ElementRef;
  @ViewChild('AJAXREQUEST', { static: true }) AJAXREQUEST: ElementRef;

  @ViewChild('formLogout', { static: true }) formLogout: ElementRef;
  @ViewChild('nevForm', { static: true }) nevForm: ElementRef;
  @ViewChild('javaxFacesViewStateLogout', { static: true }) javaxFacesViewStateLogout: ElementRef;
  @ViewChild('nevFormJ_id13', { static: true }) nevFormJ_id13: ElementRef;

  constructor(private ecomanagerService: EcomanagerService) {

    if ( this.ecomanagerService.isLoaded() ) {
      this.hasCredentials = this.ecomanagerService.getCredentialByServiceAndParam('ecompliance', 'username') != null
                            && this.ecomanagerService.getCredentialByServiceAndParam('ecompliance', 'password') != null;
      this.waitForData();
    }

  }

  waitForData(){
    setTimeout(()=>{
      if ( this.formUpdated && this.iframeLoaded) {
        setTimeout(()=>{
          this.form.nativeElement.submit();
          this.formSubmited = true;
        }, 100);

      } else {
        this.waitForData();
      }
    }, 200);
  }

  ngAfterContentInit(){
    this.formLogin.nativeElement.value = "formLogin";
    this.formLoginFirstTime.nativeElement.value = "";
    this.javaxFacesViewState.nativeElement.value = "j_id1";
    this.formLoginAceptarBtn.nativeElement.value = "formLogin:aceptarBtn";
    this.formLoginUsuario.nativeElement.value = this.ecomanagerService.getCredentialByServiceAndParam('ecompliance', 'username');
    this.formLoginPassword.nativeElement.value = this.ecomanagerService.getCredentialByServiceAndParam('ecompliance', 'password');
    this.AJAXREQUEST.nativeElement.value = "_viewRoot";
    this.formUpdated = true;
  }

  public onIframeLoaded() {
    if (!this.iframeLoaded) {
      this.iframeLoaded = true;
    }
    if ( this.formSubmited ) {
      this.isLoading = false;
    }
  }

  public ngOnDestroy(): void {
    this.nevForm.nativeElement.value = "nevForm";
    this.javaxFacesViewStateLogout.nativeElement.value = "j_id1";
    this.nevFormJ_id13.nativeElement.value = "nevForm:j_id13";
    this.formLogout.nativeElement.submit();
    this.isLoading = true;
    let timestamp = new Date().getTime() + 300;
    while ( new Date().getTime() < timestamp) {

    }
  }
}
